import { makeVar, useReactiveVar } from "@apollo/client";

import { useRouteChangeEffect } from "./useRouteChangeEffect";
const ticketModalOpen = makeVar(false);

export function useQCTicketModal() {
  const modalOpen = useReactiveVar(ticketModalOpen);
  const setModalOpen = (open: boolean) => {
    ticketModalOpen(open);
  };

  const openModal = () => {
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
  };

  useRouteChangeEffect(() => {
    if (modalOpen) {
      closeModal();
    }
  });

  return {
    modalOpen,
    openModal,
    closeModal,
  };
}
